import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { toastr } from 'react-redux-toastr';
import {
    DialogTitle,
    DialogContent,
    DialogContentText,
} from '@material-ui/core';
import { EmptyTableText, Table } from '@commonClient2/components';
import SetupEdit from './SetupEdit';
import { fetchAdminAppData } from '../store/appData';
import {
    loadSetup, deleteSetup, UPDATE_SETUP, loadDuplicateSetup, RESET_SETUP,
} from '../store/setup';
import { AdminSidePanelAction } from '../../Enums';
import columns, { renderWarningColumn, renderAutoApprovalColumn } from './SetupList.services';
import './SetupList.scss';

function SetupList() {
    const { t } = useTranslation('shiftBidding', { keyPrefix: 'admin' });
    const dispatch = useDispatch();

    /** @type {ShiftBidding.AdminStore} */
    // @ts-ignore
    const { adminAppData } = useSelector((state) => state);
    const { isAdminAppDataLoaded, setups } = adminAppData;

    const [adminSetups, setAdminSetups] = useState(setups);
    const [sidePanelOpen, setSidePanelOpen] = useState(false);

    useEffect(() => {
        if (!isAdminAppDataLoaded) {
            dispatch(fetchAdminAppData());
        }
    }, []);

    useEffect(() => {
        setAdminSetups(setups);
    }, [JSON.stringify(setups)]);

    /**
     * @param {Setup.ISetupBrief} rowData
     */
    const handleEdit = (rowData) => {
        dispatch(loadSetup(rowData.bidSetupId, AdminSidePanelAction.Edit, () => setSidePanelOpen(true)));
    };

    /**
     * @param {Setup.ISetupBrief} rowData
     */
    const handleDuplicate = (rowData) => {
        dispatch(loadDuplicateSetup(rowData.bidSetupId, AdminSidePanelAction.Duplicate, () => setSidePanelOpen(true)));
    };

    /**
     * @param {Setup.ISetupBrief} rowData
     */
    const handleDelete = (rowData) => {
        const toastrConfirmOptions = {
            onOk: () => {
                dispatch(deleteSetup(rowData.bidSetupId, { setups }));
            },
            onCancel: () => { },
            component: () => (
                <div>
                    <DialogTitle style={{ padding: '16px 24px' }}>
                        {t('setupList.delete.title')}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {t('setupList.delete.contentText', { name: rowData.name })}
                        </DialogContentText>
                    </DialogContent>
                </div>
            ),
        };
        toastr.confirm('', toastrConfirmOptions);
    };

    const handleCreateNewBid = () => {
        dispatch({
            type: RESET_SETUP,
            payload: {},
        });
        dispatch({
            type: UPDATE_SETUP,
            payload: { adminSidePanelAction: AdminSidePanelAction.Create },
        });
        setSidePanelOpen(true);
    };

    return (
        <div className="sul-full-page">
            <Table
                loading={!isAdminAppDataLoaded}
                data={adminSetups}
                columns={columns}
                customColumnRenderers={[
                    {
                        columnName: 'warning',
                        renderCell: renderWarningColumn
                    },
                    {
                        columnName: 'autoApprovalName',
                        renderCell: renderAutoApprovalColumn
                    }
                ]}
                id="admin--settings-table"
                renderEmpty={() => <EmptyTableText text={t('setupList.noBidSetupFound')} />}
                onEdit={(_, value) => handleEdit(value)}
                onCreate={handleCreateNewBid}
                createLabel={t('setupList.createNew')}
                onDuplicate={(_, value) => handleDuplicate(value)}
                onDelete={(_, value) => handleDelete(value)}
                fillAvailableHeight
                defaultSortColumnKey="name"
            />
            <SetupEdit
                open={sidePanelOpen}
                setOpen={setSidePanelOpen}
            />
        </div>
    );
}

export default SetupList;
